import React from 'react';

import styles from './RemainingRMD.module.scss';
import {
  currency,
  lastBusinessDayNumeric,
} from '../../../utils/dashboard-utils';
import MyToolTip from '../../Shared/MyToolTip/MyToolTip';

const DEFAULT_TRIGGER = (
  <p className={styles['rmd-calculated']}>How is my RMD calculated?</p>
);

const RMDCalculator = ({
 trigger,
}) => {
  return (
    <MyToolTip
      id={`rmd-calculation`}
      descriptionTitle={
        <p className={styles['rmd-poppper-title']}>How your RMD was calculated</p>
      }
      descriptionBody={
        <div className={styles['rmd-desc-body']}>
          <div className={styles['rmd-desc-left']}>
            <div className={styles['rmd-year-end']}>Year End IRA Balance</div>
              <br />
            <hr className={styles['rmd-divider']} />
            <br />
            <div className={styles['irs-lfe']}>IRS Life Expectancy Factor</div>
          </div>
          <div className={styles['rmd-desc-left']}>
            <hr className={styles['rmd-equal']} />
            <hr className={styles['rmd-equal']} />
          </div>
          <div className={styles['rmd-desc-left']}>
            <div className={styles['irs-lfe']}>
              Required Minimum Distribution
            </div>
          </div>
        </div>
      }
      popOutPlacement="top"
      callerNode={trigger || DEFAULT_TRIGGER}
      maxNoteWidth="468px"
    />
  );
};

export default RMDCalculator;
